import { FieldConfig } from "pages/employer-of-record/payments/components/Setup/components/SetupFormGenerator";
import {
  COMPONENTLIST,
  LAYOUT_OPTIONS,
} from "../../../SetupFormGenerator/constants";
import { TaxableBenefitsPaymentSettings } from "../../types";
import { BenefitsAndAllowancesType } from "pages/employer-of-record/payments/constants";

export const DEFAULT_FORM_OF_INCOME_FIELD: FieldConfig = {
  label: "Form of income",
  name: "formOfIncome",
  type: COMPONENTLIST.RADIO,
  layout: LAYOUT_OPTIONS.VERTICAL,
  options: [
    {
      value: "cash",
      label: "Cash",
      description:
        "Send a payment which will add to your employee's gross earnings and increase their take-home pay.",
    },
    {
      value: "non-cash",
      label: "Non-cash",
      description:
        "Record a payment for a benefit that's already been paid outside of Justworks. It will add to their gross earnings, but not their take-home pay.",
    },
  ],
  required: true,
};

export const DEFAULT_PAY_PERIOD_FIELD: FieldConfig = {
  label: "Pay date",
  name: "payPeriodId",
  type: COMPONENTLIST.SELECT,
  options: [{ value: "", label: "" }],
  required: true,
  disabled: false,
  disabledCheck: (data) => {
    const settings = data?.setUp.payload
      .paymentSettings as TaxableBenefitsPaymentSettings;
    const { formOfIncome } = settings;
    if (
      data?.setUp.type === BenefitsAndAllowancesType.BENEFITSANDALLOWANCES &&
      formOfIncome === "non-cash"
    ) {
      return true;
    }
    return false;
  },
  renderCheck: (data) => {
    const settings = data?.setUp.payload
      .paymentSettings as TaxableBenefitsPaymentSettings;

    const { formOfIncome } = settings;
    return formOfIncome ? true : false;
  },
  conditionalMessage: (data) => {
    const settings = data?.setUp.payload
      .paymentSettings as TaxableBenefitsPaymentSettings;
    const { formOfIncome } = settings;
    const message = {
      text: "Non-cash benefits will be applied to the next pay period.",
    };

    return formOfIncome === "non-cash" ? message : null;
  },
};

export const DEFAULT_INTERNAL_NOTES_FIELD: FieldConfig = {
  label: "Internal Notes",
  name: "notes",
  type: COMPONENTLIST.TEXTAREA,
  required: false,
  message: { text: "Only visible to admins" },
};

export const DEFAULT_MARK_RECURRING_PAYMENT_FIELD: FieldConfig = {
  label: "Make recurring",
  name: "isRecurring",
  type: COMPONENTLIST.TOGGLE,
  required: true,
};

export const DEFAULT_RECURRING_CADENCE_FIELD: FieldConfig = {
  label: "Payment Schedule",
  name: "recurringCadence",
  type: COMPONENTLIST.RADIO,
  layout: LAYOUT_OPTIONS.VERTICAL,
  required: true,
  options: [{ value: "", label: "" }],
  renderCheck: (data) => {
    const settings = data?.setUp.payload
      .paymentSettings as TaxableBenefitsPaymentSettings;

    const { isRecurring } = settings;
    return isRecurring && isRecurring.toString() === "true";
  },
};

export const DEFAULT_PAYMENT_SETTINGS_FIELDS: FieldConfig[] = [
  DEFAULT_FORM_OF_INCOME_FIELD,
  DEFAULT_PAY_PERIOD_FIELD,
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
];
